export enum DataType {
    Text = 'Text',
    Integer = 'Integer',
    Decimal = 'Decimal',
    Date = 'Date',
}
